<script>
import appConfig from '@src/app.config'

export default {
  metaInfo: {
    titleTemplate(title) {
      // title = typeof title === 'function' ? title(this.$store) : title
      // return title ? `${this.$t(`navigation_headers__${title}`)} - ${appConfig.title}` : appConfig.title
      const { name, params } = this.$route
      let subtitle = ''
      switch (name) {
        case 'document':
          subtitle += this.$t(`navigation_links__${params.documentType}`)
          subtitle += ` / ${params.documentId}`
          break
        case 'contact':
          subtitle += this.$t('navigation_links__contacts')
          subtitle += ` / ${params.contact.firstName} ${
            params.contact.lastName
          }`
          break
        case 'organization':
          subtitle += this.$t('navigation_links__organizations')
          subtitle += ` / ${params.organization.shortName}`
          break
        case 'goodsItem':
          subtitle += this.$t('navigation_links__goods')
          subtitle += ` / ${params.goodsItem.shortName}`
          break
        case 'dictionariesList':
          subtitle += this.$t('navigation_links__dictionaries')
          break
        case 'dictionary':
          subtitle += this.$t('navigation_links__dictionaries')
          subtitle += ` / ${this.$t(`label__${params.dictionary}`)}`
          break
        case 'user':
          subtitle += this.$t('navigation_links__users')
          subtitle += ` / ${params.user.firstName} ${params.user.lastName}`
          break
        case 'systemSettingsList':
          subtitle += this.$t('navigation_links__systemSettings')
          break
        case 'systemSettings':
          subtitle += this.$t('navigation_links__systemSettings')
          subtitle += ` / ${this.$t(`dictionaries__${params.dictionaryName}`)}`
          break
        case 'alerts-view':
          subtitle += this.$t('navigation_links__alerts')
          subtitle += ` / ${this.$t(`reports__${params.name}`)}`
          break
        case 'reports-view':
          subtitle += this.$t('navigation_links__reports')
          subtitle += ` / ${this.$t(`reports__${params.name}`)}`
          break
        case 'login':
          subtitle += this.$t('buttons__login')
          break
        case 'home':
          subtitle += this.$t('navigation_links__main')
          break
        case 'account':
          subtitle += this.$t('navigation_links__accountSettings')
          break
        case 'password':
          subtitle += this.$t('navigation_links__changePassword')
          break
        default:
          subtitle = this.$t(`navigation_links__${name}`)
          break
      }
      return `${subtitle} - ${appConfig.title}`
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';
@import 'utils/barcode/barcode-scanner.css';
@import 'utils/date-picker/date-picker.css';
@import 'utils/toolbar/toolbar.css';
@import 'utils/data-table/data-table.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: $color-body-bg;
}

#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}
</style>
